/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUserResponse
 */
export interface CreateUserResponse {
    /**
     * The blockchain transaction hash
     * @type {string}
     * @memberof CreateUserResponse
     */
    transactionHash?: string;
    /**
     * The blockchain block hash
     * @type {string}
     * @memberof CreateUserResponse
     */
    blockHash?: string;
    /**
     * The blockchain block number/height
     * @type {number}
     * @memberof CreateUserResponse
     */
    blockNumber?: number;
    /**
     * The ID of the created user
     * @type {string}
     * @memberof CreateUserResponse
     */
    userId?: string;
}

/**
 * Check if a given object implements the CreateUserResponse interface.
 */
export function instanceOfCreateUserResponse(value: object): value is CreateUserResponse {
    let isInstance = true;

    return isInstance;
}

export function CreateUserResponseFromJSON(json: any): CreateUserResponse {
    return CreateUserResponseFromJSONTyped(json, false);
}

export function CreateUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionHash': !exists(json, 'transaction_hash') ? undefined : json['transaction_hash'],
        'blockHash': !exists(json, 'block_hash') ? undefined : json['block_hash'],
        'blockNumber': !exists(json, 'block_number') ? undefined : json['block_number'],
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
    };
}

export function CreateUserResponseToJSON(value?: CreateUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction_hash': value.transactionHash,
        'block_hash': value.blockHash,
        'block_number': value.blockNumber,
        'user_id': value.userId,
    };
}

